module.exports = __webpack_public_path__ + "img/1716866621557-keripik Tsurayya.jpg.017d929c.webp";